<template>
  <div class="count-cell" :class="classes">{{ value + 1 }}</div>
</template>

<script>
const classes = ['is-first', 'is-secend', 'is-thrid']
export default {
  props: {
    value: {
      type: Number,
      default: 0
    },
    row: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    searchType() {
      return this.row.searchType
    },
    classes() {
      if (this.searchType !== 'supplier') return []
      const className = classes[this.value] || ''
      return [className, className ? 'is-count' : '']
    }
  }
}
</script>

<style lang="scss" scoped>
.count-cell {
  width: 28px;
  height: 28px;
  text-align: center;
  position: relative;
  z-index: 10;
  margin-right: 12px;
  font-family: 'fjallone';
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  color: #666;
  border: 1px solid #666;
  border-radius: 50%;
  &.is-count {
    border: none;
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 28px;
      height: 28px;
      border-radius: 50%;
      z-index: -5;
    }
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 20px;
      height: 20px;
      border-radius: 50%;
      z-index: -1;
    }
  }
  &.is-first {
    color: #FFE179;
    &::before {
      background: linear-gradient(to bottom right, #FFE782 0%, #FFC64F 100%);
    }
    &::after {
      background: linear-gradient(to bottom right, #FFD269 0%, #FF8F44 100%);
      box-shadow: 0px 0px 1px 0px #ffae55;
    }
  }
  &.is-secend {
    color: #E3E4E8;
    &::before {
      background: linear-gradient(to bottom right, #E0E4E7 0%, #ADB7C1 100%);
    }
    &::after {
      background: linear-gradient(to bottom right, #A9B0BA 0%, #8C9299 100%);
      box-shadow: 0px 0px 1px 0px #808890;
    }
  }
  &.is-thrid {
    color: #F1E1DB;
    &::before {
      background: linear-gradient(to bottom right, #F2D4C5 0%, #D7A68A 100%);
    }
    &::after {
      background: linear-gradient(to bottom right, #D6AE98 0%, #BA8164 100%);
      box-shadow: 0px 0px 1px 0px #b87a5e;
    }
  }
}
</style>
